import { useTranslation } from 'react-i18next';

import { Body1 } from '@myphx-engineering/phx-design-system';

import { useProgramTerms } from '../../../../../hooks/use-program-terms';
import type { PricingCardElementProps } from '../../common/shared';

export const SelfPayPricingCardSavings = ({
    medication,
    savings,
}: Omit<
    PricingCardElementProps,
    'hasIncentivePricing' | 'offer' | 'patientPay' | 'priceType'
>) => {
    const { t } = useTranslation('lilly');

    const terms = useProgramTerms(medication, 'self-pay');

    if (!savings || !terms?.incentiveProgram) {
        return <Body1>{t('fill.selfPay.pricing.subjectToChange')}</Body1>;
    }

    return (
        <Body1>
            {t('fill.selfPay.pricing.savings', {
                programName: terms.incentiveProgram.name,
                savings,
            })}
        </Body1>
    );
};
